import { Alert, Autocomplete, Box, Button, Container, FormControl, Grid, InputLabel, MenuItem, Modal, Paper, Select, SelectChangeEvent, Snackbar, TextField, Typography } from "@mui/material";
import "./styles.css";
import { CustomBox, CustomButton, TitleBar } from './../../../components';
import React, { ChangeEvent, useEffect } from "react";
import { onboardingTarjetasApi } from "../../../api/onboardingTarjetas";
import { AppStore } from "../../../redux/stores";
import { useDispatch, useSelector } from "react-redux";
import { setError } from "../../../redux/states/error";
import { VerificacionEmail } from "../VerificaciónEmail";
import { GuardarInfoPersonal, LoadingModalProps } from "../../../models";
import { resetLoading, updateLoading } from "../../../redux/states/loading";
import { PublicRoutes } from "../../../routes";
import { useNavigate, useNavigation } from "react-router-dom";
import { Height } from "@mui/icons-material";
import { createUser } from "../../../redux/states/user";


interface DatosPersonales {
    datosPersonales: {
        nombre: string;
        apellido: string;
        cuit: string;
        sexo: string;
        celular: string;
        fechaNacimiento: string;
    };
    domicilios: {
        calle: string;
        numero: number;
        piso: string;
        depto: string;
        localidadId: number;
        provinciaId: number;
        localidad: string;
        provincia: string;
        cp: number;
    };
    siguientePaso: number;
    idTramite: string;
}

const datosDefault: DatosPersonales = {
    datosPersonales: {
        nombre: "",
        apellido: "",
        cuit: "",
        sexo: "",
        celular: "",
        fechaNacimiento: ""
    },
    domicilios: {
        calle: "",
        numero: 0,
        piso: "",
        depto: "",
        localidadId: 0,
        provinciaId: 0,
        localidad: "",
        provincia: "",
        cp: 0
    },
    siguientePaso: 0,
    idTramite: ""
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
        xs: 350,
        sm: 300,
        md: 800
    },
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: {
        xs: 5,
        md: 5

    },
    boxShadow: 24,
    p: {
        xs: 'none',
        md: 4
    },
};

const inputStyle = {
    "& .MuiInputBase-root": {
        fontSize: {
            xs: "0.5rem",
            md: "1.0rem"
        },
        height: {
            xs: "2rem",
            md: "3.5rem"
        },
    },
};

const inputStyleTwo = {
    "& .MuiInputBase-root": {
        fontSize: {
            xs: "0.7rem",
            md: "1.0rem"
        },
        height: {
            xs: "3rem",
            md: "4rem"
        },
    },
};

const SizeTextLabel = {
    fontSize: {
        xs: "0.7rem",
        md: "1.2rem"
    },
    fontWeight: '700'
}


interface infoSnack {
    open: boolean,
    message: string
}

const defaultSnack: infoSnack = {
    open: false,
    message: ''
};

interface IopenSnack {
    open: boolean;
    message: string;
}

interface IProvincias {
    cP_IDPROVINCIA: number;
    cP_DESCRIPCION: string;
    cP_HABILITADO: 'S' | 'N';
    cP_USERID: string;
    cP_FECPRO: string;
    cP_IDPROV_COLUMBIA: number;
}

interface ILocalidad {
    cL_ID_LOCALIDAD: number;
    cL_DESCRIPCION: string;
    cL_HABILITADO: 'S' | 'N';
    cL_USERID: string;
    cL_FECPRO: string;
}

interface ICP {
    cP_ID: string;
    cP_ID_PROVINCIA: number;
    cP_ID_LOCALIDAD: number;
    cP_USERID: string;
    cP_FECPRO: string;
}

type ISetOpenSnack = (datos: IopenSnack) => void;

const VerificarEmailModal: React.FC<{ onSetOpen: boolean, onUpModal: (value: boolean) => void, idtramite: string, email: string, onOpenSnack: ISetOpenSnack }> = ({ onSetOpen, onUpModal, idtramite, email, onOpenSnack }) => {
    const [open, setOpen] = React.useState(onSetOpen);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>

            <Modal
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box sx={style}>
                    <VerificacionEmail onUpModal={onUpModal} idtramite={idtramite} email={email} onOpenSnack={onOpenSnack} onSetPopUp={setOpen} />
                </Box>
            </Modal>
        </React.Fragment>
    );
}


const PersonalInfo: React.FC = () => {
    const [name, setName] = React.useState("");
    const [apellido, setAPellido] = React.useState("");
    const [cuit, setCuil] = React.useState("");
    const [sexo, setSexo] = React.useState("");
    const [fechaNacimiento, setFechaNacimiento] = React.useState("");
    const [actividad, setActividad] = React.useState("")
    const [telefono, setTelefono] = React.useState("")

    const [calle, setCalle] = React.useState("");
    const [numero, setNumero] = React.useState("");
    const [piso, setPiso] = React.useState<number>(0);
    const [dpto, setDepto] = React.useState("");
    const [EstadoLocalidad, setEstadoLocalidad] = React.useState("");
    const [localidadId, setLocalidadId] = React.useState<number>(0);
    const [provincia, setProvincia] = React.useState("");
    const [provinciaId, setProvinciaId] = React.useState<number>(0);
    const [EstadoCp, setEstadoCp] = React.useState<string>("");
    const [email, setCorreo] = React.useState("");
    const [confirmaCorreo, setConfirmaCorreo] = React.useState("");
    const [listProvincias, setListProvincias] = React.useState<IProvincias[]>([]);
    const [provinciaSeleccionada, setProvinciaSeleccionada] = React.useState<IProvincias | null>(null);
    const [listLocalidades, setListLocalidades] = React.useState<ILocalidad[]>([]);
    const [localidadSeleccionada, setLocalidadSeleccionada] = React.useState<ILocalidad | null>(null);
    const [listCP, setListCP] = React.useState<ICP[]>([]);
    const [CPseleccionado, setCPseleccionado] = React.useState<ICP | null>(null);
    const [datosPersonales, setDatosPersonales] = React.useState<DatosPersonales>(datosDefault);
    const [sexoObtenido, setSexoObtenido] = React.useState<string>("");

    const [idtramite, setIdTramite] = React.useState("");
    const [disableContinuar, setdisableContinuar] = React.useState(true);
    const [upVerificarEmail, setUpVerificarEmail] = React.useState(false);
    const [openSnack, setopenSnack] = React.useState<infoSnack>(defaultSnack);

    const navigate = useNavigate();
    const sexos = {
        "M": "MASCULINO",
        "F": "FEMENINO"
    }
    const dispatch = useDispatch();

    //Recuperar el idTramite
    let userIdTramite = useSelector((state: AppStore) => state.user.idTramite);
    //Solo para pruebas, eliminar o comentar antes de salir a producción
    // if (!userIdTramite || userIdTramite.trim() === "") {
    // userIdTramite = "2af9c594-3bb4-4ef0-bb39-19494723c56a";
    // dispatch(createUser({
    //     idTramite: userIdTramite,
    //     name: "",
    //     surname: "",
    //     cuit: "",
    //     dnn: "",
    //     telefono: ""
    // }));
    // }

    useEffect(() => {
        dispatch(updateLoading({ openLM: true, messageLM: 'Cargando su información...' }));
        console.log(userIdTramite);
        setIdTramite(userIdTramite);

    }, [userIdTramite]);

    useEffect(() => {
        console.log(idtramite);

        // Obtener provincias
        onboardingTarjetasApi.Getprovincias()
            .then((response) => {
                console.log(response.data);
                if (response.data.resultado) {
                    setListProvincias(response.data.datos);
                } else {
                    handleError(
                        response.data.errores?.idError || "54",
                        response.data.errores?.mensaje || "No se pudieron cargar las provincias."
                    );
                }
            })
            .catch((error) => {
                if (error.response) {
                    const statusCode = error.response.status;
                    const statusMessage = error.response.statusText;

                    handleError(
                        statusCode.toString(),
                        `Error al obtener provincias: ${statusMessage || "Error desconocido"}`
                    );
                } else if (error.request) {
                    handleError(
                        "54",
                        "No se recibió respuesta del servidor al obtener provincias."
                    );
                } else {
                    handleError(
                        "54",
                        `Error al configurar la solicitud al obtener provincias: ${error.message}`
                    );
                }
            });

        // Obtener información personal
        onboardingTarjetasApi.preInfoPersonal(userIdTramite)
            .then((response) => {
                console.log(response.data);
                if (response.data.resultado) {
                    console.log(response.data);
                    const datosResponse = response.data.datos;
                    console.log(datosResponse);
                    dispatch(resetLoading());

                    setName(datosResponse.datosPersonales.nombre);
                    setAPellido(datosResponse.datosPersonales.apellido);
                    setCuil(datosResponse.datosPersonales.cuit);
                    setSexo(datosResponse.datosPersonales.sexo);
                    setFechaNacimiento(
                        datosResponse.datosPersonales.fechA_NACIMIENTO
                            .replace("T00:00:00", "")
                            .split("-")
                            .reverse()
                            .join("-")
                    );
                    setTelefono(datosResponse.datosPersonales.celular);

                    setCalle(datosResponse.domicilios.calle);
                    setNumero(datosResponse.domicilios.numero);
                    setPiso(datosResponse.domicilios.piso ?? 0);
                    setDepto(datosResponse.domicilios.depto ?? "");
                    setEstadoLocalidad(datosResponse.domicilios.localidad);
                    setProvinciaId(datosResponse.domicilios.localidadId);
                    setProvincia(datosResponse.domicilios.provincia);
                    setProvinciaId(datosResponse.domicilios.provinciaId);
                    setEstadoCp(datosResponse.domicilios.cp);
                } else {
                    handleError(
                        response.data.errores?.idError || "54",
                        response.data.errores?.mensaje || "No se pudo cargar los datos del cliente."
                    );
                    dispatch(resetLoading());
                }
            })
            .catch((error) => {
                if (error.response) {
                    const statusCode = error.response.status;
                    const statusMessage = error.response.statusText;

                    handleError(
                        statusCode.toString(),
                        `Error al obtener información personal: ${statusMessage || "Error desconocido"}`
                    );
                } else if (error.request) {
                    handleError(
                        "54",
                        "No se recibió respuesta del servidor al obtener información personal."
                    );
                } else {
                    handleError(
                        "54",
                        `Error al configurar la solicitud al obtener información personal: ${error.message}`
                    );
                }
            });
    }, []);


    useEffect(() => {
        console.log(listProvincias);
        const infoProvincia = findInfoProvinciaByName(provincia, listProvincias);
        console.log(infoProvincia);
        setProvinciaSeleccionada(infoProvincia != undefined && infoProvincia != null ? infoProvincia : null);

    }, [provincia]);

    useEffect(() => {
        if (provinciaSeleccionada != null) {
            onboardingTarjetasApi
                .GetLocalidadByProvincia(provinciaSeleccionada.cP_IDPROVINCIA)
                .then((response) => {
                    if (response.data.resultado) {
                        const localidades: ILocalidad[] = response.data.datos;
                        setListLocalidades(localidades);

                        const datosLocalidad = localidades.find(
                            (localidad) => localidad.cL_DESCRIPCION.toLowerCase() === EstadoLocalidad.toLowerCase()
                        );

                        if (datosLocalidad != undefined && datosLocalidad != null) {
                            setLocalidadSeleccionada(datosLocalidad);
                        }
                    } else {
                        handleError(
                            response.data.errores?.idError || "54",
                            response.data.errores?.mensaje || "No se pudieron cargar las localidades de la provincia seleccionada."
                        );
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        const statusCode = error.response.status;
                        const statusMessage = error.response.statusText;

                        handleError(
                            statusCode.toString(),
                            `Error al obtener localidades: ${statusMessage || "Error desconocido"}`
                        );
                    } else if (error.request) {
                        handleError(
                            "54",
                            "No se recibió respuesta del servidor al obtener localidades."
                        );
                    } else {
                        handleError(
                            "54",
                            `Error al configurar la solicitud al obtener localidades: ${error.message}`
                        );
                    }
                });
        }
    }, [provinciaSeleccionada]);

    useEffect(() => {
        if (localidadSeleccionada != null) {
            onboardingTarjetasApi
                .GetCPLocalidad(localidadSeleccionada.cL_ID_LOCALIDAD)
                .then((response) => {
                    if (response.data.resultado) {
                        const CPs: ICP[] = response.data.datos;
                        setListCP(CPs);

                        const CPObtenido = CPs.find((cp) => cp.cP_ID == EstadoCp);

                        if (CPObtenido != undefined && CPObtenido != null) {
                            setCPseleccionado(CPObtenido);
                        }
                    } else {
                        handleError(
                            response.data.errores?.idError || "54",
                            response.data.errores?.mensaje || "No se pudieron cargar los códigos postales de la localidad seleccionada."
                        );
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        const statusCode = error.response.status;
                        const statusMessage = error.response.statusText;

                        handleError(
                            statusCode.toString(),
                            `Error al obtener códigos postales: ${statusMessage || "Error desconocido"}`
                        );
                    } else if (error.request) {
                        handleError(
                            "54",
                            "No se recibió respuesta del servidor al obtener códigos postales."
                        );
                    } else {
                        handleError(
                            "54",
                            `Error al configurar la solicitud al obtener códigos postales: ${error.message}`
                        );
                    }
                });
        }
    }, [localidadSeleccionada]);


    function findInfoProvinciaByName(nombre: string, provincias: IProvincias[]): IProvincias | null | undefined {
        return provincias.find(provincia => provincia.cP_DESCRIPCION.toLowerCase() === nombre.toLowerCase());
    };

    const handleCalle = (event: ChangeEvent<HTMLInputElement>) => {
        setCalle(event.target.value);
    }
    const handleNumero = (event: ChangeEvent<HTMLInputElement>) => {
        setNumero(event.target.value);
    }
    const handlePiso = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setPiso(value ? parseInt(value, 10) : 0);
    };
    const handleDepto = (event: ChangeEvent<HTMLInputElement>) => {
        setDepto(event.target.value);
    }
    const handleCorreo = (event: ChangeEvent<HTMLInputElement>) => {
        setCorreo(event.target.value);
    }
    const handleConfirmaCorreo = (event: ChangeEvent<HTMLInputElement>) => {
        setConfirmaCorreo(event.target.value);
    }

    const handleCloseSnack = () => { setopenSnack({ open: false, message: '' }) };

    useEffect(() => {
        validateForm();
    }, [calle, numero, EstadoLocalidad, provincia, EstadoCp, email, confirmaCorreo]);

    const validateForm = () => {
        const requiredFields = [calle, numero, EstadoLocalidad, provincia, EstadoCp, email, confirmaCorreo];

        const hasEmptyField = requiredFields.some(field => !field);

        if (hasEmptyField) {
            setdisableContinuar(true);
            return false;
        }

        setdisableContinuar(false);
        return true;
    };

    async function GuardarInfoPersonal() {
        try {
            if (email !== confirmaCorreo) {
                setopenSnack({ open: true, message: 'Los Correos tienen que ser iguales' });
                return;
            }

            dispatch(updateLoading({ openLM: true, messageLM: 'Guardando su información...' }));

            const info: GuardarInfoPersonal = {
                idtramite,
                calle,
                numero: parseInt(numero),
                piso: piso.toString(),
                dpto,
                localidad: localidadSeleccionada?.cL_DESCRIPCION ?? '',
                localidadId: localidadSeleccionada?.cL_ID_LOCALIDAD ?? -1,
                provincia: provinciaSeleccionada?.cP_DESCRIPCION ?? '',
                provinciaId: provinciaSeleccionada?.cP_IDPROVINCIA ?? -1,
                codigoPostal: CPseleccionado?.cP_ID.toString() ?? '',
                email,
            };

            console.log(info);

            const response = await onboardingTarjetasApi.saveInfoPersonal(info);

            console.log("Entró al API:", response.data);
            dispatch(resetLoading());

            if (response.data.resultado) {
                console.log("Datos guardados correctamente:", response.data.datos);
                setUpVerificarEmail(true);
            } else {
                handleError(
                    response.data.errores?.idError || "54",
                    "Hubo un error al intentar guardar su información personal."
                );
                setUpVerificarEmail(false);
            }
        } catch (error: any) {
            dispatch(resetLoading());

            if (error.response) {
                // La API respondió con un código de estado HTTP
                const statusCode = error.response.status;
                const statusMessage = error.response.statusText;

                console.error("Error Status Code:", statusCode);
                console.error("Error Status Message:", statusMessage);

                handleError(
                    statusCode.toString(),
                    `Hubo un error al intentar guardar su información personal: ${statusMessage}`
                );
            } else if (error.request) {
                // No se recibió respuesta del servidor
                console.error("No response from server:", error.request);

                handleError(
                    "54",
                    "Hubo un error al intentar guardar su información personal."
                );
            } else {
                // Error al configurar la solicitud
                console.error("Error setting up the request:", error.message);

                handleError(
                    "54",
                    `Hubo un error al intentar guardar su información personal: ${error.message}`
                );
            }

            setUpVerificarEmail(false);
        }
    }

    const handleError = (idError: string, message: string) => {
        console.error(message);

        dispatch(setError({
            idError: idError,
            mensaje: message,
        }));

        setopenSnack({ open: true, message: message });

        setTimeout(() => {
            dispatch(resetLoading());
            navigate(`/${PublicRoutes.ERROR}`, { replace: true });
        }, 2000);
    };

    return (
        <>
            <Box sx={{ width: 500 }}>
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={openSnack.open}
                    onClose={handleCloseSnack}
                    autoHideDuration={6000}
                    key={"top" + "center"}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {openSnack.message}
                    </Alert>
                </Snackbar>
            </Box>
            <Container maxWidth="md" sx={{ bgcolor: '#FFFFFF', p: 2, mt: 4 }}>

                <Grid container sx={{ padding: { xs: 0, md: "5px" } }} spacing={{ xs: 1, md: 2 }}>
                    <Grid item xs={12}>
                        <TitleBar text="Información Personal" />
                    </Grid>

                    <Grid item xs={2} textAlign="left">
                        <Box sx={{ paddingTop: '10%' }}>
                            <Typography sx={SizeTextLabel} variant="body1" textAlign="right" gutterBottom>
                                Nombre:
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        {/* <CustomBox text={name}/> */}
                        <TextField sx={inputStyle} fullWidth id="outlined-basic" label="" variant="outlined" value={name} disabled />
                    </Grid>

                    <Grid item xs={2} >
                        <Box sx={{ paddingTop: '10%' }}>
                            <Typography sx={SizeTextLabel} variant="body1" textAlign="right" gutterBottom>
                                Apellido:
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={4} textAlign="left">
                        {/* <CustomBox text={apellido}/> */}
                        <TextField sx={inputStyle} fullWidth id="outlined-basic" label="" variant="outlined" value={apellido} disabled />
                    </Grid>

                    <Grid item xs={2} textAlign="left">
                        <Box sx={{ paddingTop: '10%' }}>
                            <Typography sx={SizeTextLabel} variant="body1" textAlign="right" gutterBottom>
                                Cuil/Cuit:
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField sx={inputStyle} fullWidth id="outlined-basic" label="" variant="outlined" value={cuit} disabled />
                    </Grid>

                    <Grid item xs={2} textAlign="right">
                        <Box sx={{ paddingTop: '10%' }}>
                            <Typography sx={SizeTextLabel} variant="body1" textAlign="right" gutterBottom>
                                Sexo:
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField sx={inputStyle} fullWidth id="outlined-basic" label="" variant="outlined" value={sexo == "" ? "" : sexo == "M" ? "MASCULINO" : "FEMENINO"} disabled />
                    </Grid>

                    <Grid item xs={2} textAlign="left">
                        <Box sx={{ paddingTop: '1%' }}>
                            <Typography sx={{ ...SizeTextLabel, fontSize: { xs: '0.65rem', md: '1.2rem' } }} variant="body1" textAlign="right" gutterBottom>
                                Fecha de nacimiento:
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField sx={inputStyle} fullWidth id="outlined-basic" label="" variant="outlined" value={fechaNacimiento} disabled />
                    </Grid>

                    <Grid item xs={2} textAlign="right">
                        <Box sx={{ paddingTop: '10%' }}>
                            <Typography sx={SizeTextLabel} variant="body1" textAlign="right" gutterBottom>
                                Teléfono:
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField sx={inputStyle} fullWidth id="outlined-basic" label="" variant="outlined" value={telefono} disabled />
                    </Grid>

                    <Grid item xs={12}>
                        <TitleBar text="Domicilio" />
                    </Grid>

                    <Grid item xs={6}>
                        <Typography sx={SizeTextLabel} variant="body1" gutterBottom>Calle: </Typography>
                        <TextField sx={inputStyleTwo} fullWidth id="outlined-basic" label="" variant="outlined" onChange={handleCalle} value={calle} />
                    </Grid>

                    <Grid item xs={2}>
                        <Typography sx={SizeTextLabel} variant="body1" gutterBottom>Numero:</Typography>
                        <TextField sx={inputStyleTwo} id="outlined-basic" label="" variant="outlined" onChange={handleNumero} value={numero} />
                    </Grid>

                    <Grid item xs={2}>
                        <Typography sx={SizeTextLabel} variant="body1" gutterBottom>Piso:</Typography>
                        <TextField sx={inputStyleTwo} id="outlined-basic" label="" variant="outlined" onChange={handlePiso} value={piso} />
                    </Grid>

                    <Grid item xs={2}>
                        <Typography sx={SizeTextLabel} variant="body1" gutterBottom>Depto:</Typography>
                        <TextField sx={inputStyleTwo} id="outlined-basic" label="" variant="outlined" onChange={handleDepto} value={dpto} />
                    </Grid>

                    <Grid item xs={12} md={4} lg={4} xl={4}>
                        <Typography sx={SizeTextLabel} variant="body1" gutterBottom>Provicia:</Typography>
                        <Autocomplete
                            id="country-select-demo"
                            sx={{ ...inputStyleTwo, width: { xs: "100%", md: 250 } }}
                            options={listProvincias}
                            value={provinciaSeleccionada}
                            autoHighlight
                            getOptionLabel={(option) => option.cP_DESCRIPCION}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                    key={option.cP_IDPROVINCIA}
                                >
                                    {option.cP_DESCRIPCION}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "new-password" // disable autocomplete and autofill
                                    }}
                                />
                            )}
                            onChange={(event, provinciaSelccionada) => {
                                console.log(provinciaSelccionada);
                                setLocalidadSeleccionada(null);
                                setCPseleccionado(null);
                                setProvinciaSeleccionada(provinciaSelccionada);

                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4} lg={4} xl={4}>
                        <Typography sx={SizeTextLabel} variant="body1" gutterBottom>Localidad:</Typography>
                        <Autocomplete
                            id="country-select-demo"
                            sx={{ ...inputStyleTwo, width: { xs: "100%", md: 250 } }}
                            options={listLocalidades}
                            value={localidadSeleccionada}
                            autoHighlight
                            getOptionLabel={(option) => option.cL_DESCRIPCION}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                    key={option.cL_ID_LOCALIDAD}
                                >
                                    {option.cL_DESCRIPCION}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "new-password" // disable autocomplete and autofill
                                    }}
                                />
                            )}
                            onChange={(event, localidadSeleccionada) => {
                                console.log(localidadSeleccionada);
                                setLocalidadSeleccionada(localidadSeleccionada);
                                setCPseleccionado(null);
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={4} lg={4} xl={4}>
                        <Typography sx={SizeTextLabel} variant="body1" gutterBottom>CP:</Typography>
                        <Autocomplete
                            id="country-select-demo"
                            sx={{ ...inputStyleTwo, width: { xs: "100%", md: 250 } }}
                            options={listCP}
                            value={CPseleccionado}
                            autoHighlight
                            getOptionLabel={(option) => option.cP_ID.toString()}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                    {...props}
                                    key={option.cP_ID}
                                >
                                    {option.cP_ID}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "new-password" // disable autocomplete and autofill
                                    }}
                                />
                            )}
                            onChange={(event, CPseleccionado) => {
                                console.log(CPseleccionado);
                                setCPseleccionado(CPseleccionado);
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TitleBar text="Correo Electronico" />
                    </Grid>

                    <Grid item xs={12} sm={2} textAlign="right">
                        <Box sx={{ paddingTop: { xs: "5px", md: '10%' } }}>
                            <Typography sx={{ ...SizeTextLabel, textAlign: { xs: "left", md: "right" } }} variant="body1" gutterBottom>
                                Email:
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={4} >
                        <TextField sx={inputStyleTwo} fullWidth id="outlined-basic" label="" variant="outlined" onChange={handleCorreo} value={email} />
                    </Grid>

                    <Grid item xs={12} sm={2} textAlign="right">
                        <Typography sx={{ ...SizeTextLabel, textAlign: { xs: "left", md: "none" } }} variant="body1" gutterBottom>Confirmar Email:</Typography>
                    </Grid>

                    <Grid item xs={12} sm={4} >
                        <TextField sx={inputStyleTwo} fullWidth id="outlined-basic" label="" variant="outlined" onChange={handleConfirmaCorreo} value={confirmaCorreo} />
                    </Grid>

                    <Grid item xs={12} textAlign="center" mt={2} mb={3}>
                        {upVerificarEmail ?
                            <VerificarEmailModal onSetOpen={upVerificarEmail} onUpModal={setUpVerificarEmail} idtramite={idtramite} email={email} onOpenSnack={setopenSnack} /> :
                            <CustomButton text="Continuar" onClick={GuardarInfoPersonal} disabled={disableContinuar} />
                        }
                    </Grid>

                </Grid>
            </Container>
        </>

    );
};

export default PersonalInfo;